import React from 'react';
import { Chip, Tooltip, Box, Typography } from '@mui/material';
import { translateStatus } from '../../../Utils/statusTranslations';

function StatusChip({ invoice, styles }) {
    const translatedStatus = translateStatus(invoice.status);
    
    if (invoice.errorDetails) {
        return (
            <Tooltip
                title={
                    <Box>
                        <Typography variant="body2" sx={{ fontWeight: 'bold', mb: 1 }}>
                            {invoice.errorDetails.hebrewMessage}
                        </Typography>
                        <Typography variant="body2">
                            {invoice.errorDetails.tooltip}
                        </Typography>
                    </Box>
                }
                arrow
            >
                <Chip
                    label={translatedStatus}
                    size="small"
                    sx={{
                        ...styles.statusChip(invoice.status),
                        cursor: 'help'
                    }}
                />
            </Tooltip>
        );
    }
    
    if (invoice.autoApproved && invoice.autoApprovalReason) {
        return (
            <Tooltip
                title={
                    <Box>
                        <Typography variant="body2" sx={{ fontWeight: 'bold', mb: 1 }}>
                            ✅ אושר אוטומטית
                        </Typography>
                        <Typography variant="body2">
                            {invoice.autoApprovalReason}
                        </Typography>
                    </Box>
                }
                arrow
            >
                <Chip
                    label={translatedStatus}
                    size="small"
                    sx={{
                        ...styles.statusChip(invoice.status),
                        cursor: 'help'
                    }}
                />
            </Tooltip>
        );
    }
    
    return (
        <Chip
            label={translatedStatus}
            size="small"
            sx={styles.statusChip(invoice.status)}
        />
    );
}

export default StatusChip;
